// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"f8f18496","75":"03133586","77":"32596457","130":"c72a9f81","152":"d7fb8d80","453":"ed3810f9","499":"03e54cbc","518":"ec55eb76","525":"c56d1e02"}[chunkId] + ".chunk.js";
};